export default {"src":"/_next/static/media/linkedin-share-button-icon.11651736.svg","height":160,"width":512,"blurWidth":0,"blurHeight":0};